<template>
  <div v-if="visible" class="contract-details" v-loading="loading">
    <div class="details-header">
      <div class="tw-flex tw-items-center">
        <div
          v-if="!isDialog"
          class="tw-inline-block tw-cursor-pointer tw-mr-[16px]"
          style="color: #999999"
          @click="back"
        >
          <span class="icon iconfont icon-left" />
          <span>返回</span>
        </div>
        <div class="title">合同详情页</div>
      </div>
      <div>
        <RxkButton
          type="primary"
          @click="handleSend"
          :loading="sendLoading"
          v-if="
            getBtnShowByStatus('SENDCONTRACT', info.status) &&
            getAuthByMenuCode(menuCode, 'DETAIL_SENDCONTRACT')
          "
        >
          发送合同
        </RxkButton>
        <RxkButton
          @click="preview"
          v-if="
            getBtnShowByStatus('PREVIEW', info.status) &&
            getAuthByMenuCode(menuCode, 'DETAIL_PREVIEW')
          "
        >
          预览
        </RxkButton>
        <RxkButton
          @click="handleSend"
          :loading="sendLoading"
          v-if="
            getBtnShowByStatus('RESEND', info.status) &&
            getAuthByMenuCode(menuCode, 'DETAIL_RESEND')
          "
        >
          再次发送
        </RxkButton>
        <RxkButton
          @click="revoke"
          :loading="revokeLoading"
          v-if="
            getBtnShowByStatus('REVOCATION', info.status) &&
            getAuthByMenuCode(menuCode, 'DETAIL_REVOCATION')
          "
        >
          撤回
        </RxkButton>
        <RxkButton
          @click="download"
          :loading="downloadLoading"
          v-if="
            getBtnShowByStatus('DOWNLOAD', info.status) &&
            getAuthByMenuCode(menuCode, 'DETAIL_DOWNLOAD')
          "
        >
          下载
        </RxkButton>
        <el-dropdown class="tw-ml-3">
          <RxkButton
            v-if="
              getBtnShowByStatus('EDIT', info.status) || getBtnShowByStatus('DELETE', info.status)
            "
          >
            更多
          </RxkButton>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                @click="handleEdit"
                v-if="
                  getBtnShowByStatus('EDIT', info.status) &&
                  getAuthByMenuCode(menuCode, 'DETAIL_EDIT')
                "
              >
                编辑
              </el-dropdown-item>
              <el-dropdown-item
                @click="handleDelete"
                :loading="deleteLoading"
                v-if="
                  getBtnShowByStatus('DELETE', info.status) &&
                  getAuthByMenuCode(menuCode, 'DETAIL_DELETE')
                "
              >
                删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div v-if="isDialog" class="tw-inline-block tw-cursor-pointer" @click="back">
          <span class="icon iconfont icon-close" />
        </div>
      </div>
    </div>
    <div class="content">
      <div
        class="tw-flex-1 tw-h-full tw-p-[20px]"
        v-loading="urlLoading"
        style="background-color: #c7c9cc"
      >
        <iframe width="100%" height="100%" style="border: none" :src="contractUrl" />
      </div>
      <div class="right">
        <div class="flow-sub-title !tw-mt-0">基础信息</div>
        <div class="item-row">
          <span class="label">合同编号：</span>
          <span class="text">{{ info.contractCode || '-' }}</span>
        </div>
        <div class="item-row">
          <span class="label">合同模板：</span>
          <el-tooltip :content="info.templateName">
            <span class="text tw-truncate tw-mr-4" style="max-width: 130px">
              {{ info.templateName || '-' }}
            </span>
          </el-tooltip>
          <RxkButton
            v-if="info.signWay !== 3"
            class="tw-flex-shrink-0 table-action-btn"
            text
            :loading="templateLoading"
            @click="previewTemplate"
          >
            预览
          </RxkButton>
        </div>
        <div class="item-row">
          <span class="label">合同名称：</span>
          <span class="text">{{ info.contractName || '-' }}</span>
        </div>
        <div class="item-row">
          <span class="label">签署客户：</span>
          <span class="text">{{ info.customerName || '-' }}</span>
        </div>
        <div class="item-row">
          <span class="label">签署客户手机号：</span>
          <span class="text">{{ info.customerPhone || '-' }}</span>
        </div>
        <!--        <div class="item-row" >-->
        <!--          <span class="label">签署链接：</span>-->
        <!--          <span class="text">{{info.signUrl || '-'}}</span>-->
        <!--          <el-link class="tw-ml-4 tw-flex-shrink-0 tw-mt-1"-->
        <!--                   type="primary"-->
        <!--                   :underline="false"-->
        <!--                   v-if="info.signUrl"-->
        <!--                   @click="copyLink">复制</el-link>-->
        <!--        </div>-->
        <div class="flow-sub-title">签署方</div>
        <template v-for="item in signList" :key="item.id">
          <div class="tw-flex tw-items-center">
            <span class="text tw-mr-4">{{ item.signPersonName }}</span>
            <el-tag>{{ item.type }}</el-tag>
          </div>
          <div class="label tw-mt-1">{{ item.signCompanyName }}</div>
          <div class="label tw-mt-1">{{ item.signCompanyCode }}</div>
          <div class="label tw-mt-1">{{ item.signPersonIdCard }}</div>
          <div class="label tw-mt-1">{{ item.signPersonPhone }}</div>
          <div class="label tw-mt-1 tw-flex tw-items-center" v-if="item.signUrl">
            <span class="tw-mr-2">{{ item.signUrl || '-' }}</span>
            <RxkButton
              class="tw-flex-shrink-0 table-action-btn"
              text
              @click="copyLink(item.signUrl)"
            >
              复制
            </RxkButton>
          </div>
          <!--          <StatusItem :info="item"/>-->
        </template>
        <div class="flow-sub-title">系统信息</div>
        <div class="item-row">
          <span class="label">创建人：</span>
          <span class="text">{{ info.createByName || '-' }}</span>
        </div>
        <div class="item-row">
          <span class="label">创建时间：</span>
          <span class="text">{{ info.createTime || '-' }}</span>
        </div>
        <div class="item-row">
          <span class="label">最新修改人：</span>
          <span class="text">{{ info.updateByName || '-' }}</span>
        </div>
        <div class="item-row">
          <span class="label">最新修改时间：</span>
          <span class="text">{{ info.updateTime || '-' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {
  sendContract,
  getContractDetails,
  revokeContract,
  deleteContract,
  afterSaveView,
  preSaveView,
  getOrgAuth,
  previewRescission
} from '@/apis/erp/contractManage'
import { signMainList } from '@/views/erp/systemManage/toolsPackage/contractTemplate/components/enum'
import { getPreviewTemplateLink } from '@/apis/erp/contractTemplate'
import { contractStatusValue } from '@/views/erp/base/contractManage/enum'
import { copyText } from '@/utils'
import { noAuthDialog } from '@/views/erp/base/contractManage/utils'
import { useResource } from '@/hooks/useResource'
import { downLoadContract } from '../utils'
const { getAuthByMenuCode } = useResource()
const menuCode = 'ContractManage'

const emits = defineEmits(['update:modelValue', 'edit', 'reload'])
const props = defineProps({
  modelValue: Boolean,
  contractId: {
    type: [String, Number],
    default: ''
  },
  isDialog: Boolean,
  type: Number, // 我发起的 我签署的
  contractType: {
    type: String as PropType<'sign' | 'remove'>, // sign 签约的合同  remove 作废的合同
    default: 'sign'
  }
})
const visible = computed({
  get: () => props.modelValue,
  set: val => {
    emits('update:modelValue', val)
  }
})

const contractUrl = ref('')

function back() {
  emits('update:modelValue', false)
}

watch(visible, val => {
  if (val) {
    queryDetails()
  }
})

async function queryDetails() {
  info.value = {}
  signList.value = []
  contractUrl.value = ''
  await getDetails()
  await getUrl()
}

const signList = ref<Recordable[]>([])

const loading = ref(false)
const info = ref<Recordable>({})
async function getDetails() {
  let list = []
  try {
    loading.value = true
    const res = (await getContractDetails({ id: props.contractId, isView: true })) || {}
    info.value = res
    list = JSON.parse(res.signInfoStr)
  } finally {
    loading.value = false
    signList.value = list?.map((item: Recordable) => {
      const res = signMainList.find(e => e.value === item.type)
      return {
        ...item,
        type: res?.label || ''
      }
    })
  }
}

const urlLoading = ref(false)
async function getUrl() {
  try {
    let api = afterSaveView
    if (
      info.value.status === contractStatusValue.unSend ||
      info.value.status === contractStatusValue.fail
    ) {
      api = preSaveView
    }
    if (props.contractType === 'remove') {
      api = previewRescission
    }
    urlLoading.value = true
    contractUrl.value = await api({ id: props.contractId })
  } finally {
    urlLoading.value = false
  }
}

// 操作相关
const sendLoading = ref(false)
const revokeLoading = ref(false)
const deleteLoading = ref(false)
const downloadLoading = ref(false)

async function handleSend() {
  try {
    sendLoading.value = true
    const res = await getOrgAuth()
    if (res?.resultBoo) {
      await sendContract({ id: props.contractId })
      ElMessage.success('发送成功！')
      emits('reload')
      await queryDetails()
    } else {
      noAuthDialog(() => {
        emits('update:modelValue', false)
      })
    }
  } finally {
    sendLoading.value = false
  }
}

function preview() {
  if (contractUrl.value) {
    window.open(contractUrl.value)
  } else {
    ElMessage.error('获取文件失败，无法预览！')
  }
}

async function revoke() {
  ElMessageBox.confirm('确定要撤销此合同吗？', '提示').then(async () => {
    try {
      revokeLoading.value = true
      await revokeContract({ signFlowId: info.value.flowId })
      ElMessage.success('撤销成功！')
      emits('reload')
      await queryDetails()
    } finally {
      revokeLoading.value = false
    }
  })
}

async function download() {
  try {
    downloadLoading.value = true
    await downLoadContract(props.contractId, props.contractType)
  } finally {
    downloadLoading.value = false
  }
}

function handleEdit() {
  emits('edit', { id: props.contractId, templateId: info.value.templateId })
  emits('update:modelValue', false)
}

function handleDelete() {
  ElMessageBox.confirm('确定要删除此合同吗？', '提示').then(async () => {
    try {
      deleteLoading.value = true
      await deleteContract({ id: props.contractId })
      ElMessage.success('删除成功！')
      emits('reload')
      emits('update:modelValue', false)
    } catch (e) {
      console.log(e)
    } finally {
      deleteLoading.value = false
    }
  })
}

const templateLoading = ref(false)
async function previewTemplate() {
  try {
    templateLoading.value = true
    const res = await getPreviewTemplateLink({
      templateId: info.value.templateId
    })
    window.open(res?.resultStr)
  } finally {
    templateLoading.value = false
  }
}

function copyLink(url: string) {
  copyText(url).then(() => {
    ElMessage({
      message: '复制成功',
      type: 'success'
    })
  })
}

/**
 * 合同按钮权限控制
 * @param code
 * @param status 合同状态
 */
function getBtnShowByStatus(code: string, status: number): boolean {
  const noSelfHidden = ['SENDCONTRACT', 'EDIT', 'DELETE', 'REVOCATION', 'RESEND']
  if (props.type === 2 && noSelfHidden.includes(code)) return false
  switch (status) {
    case contractStatusValue.unSend:
      return ['SENDCONTRACT', 'PREVIEW', 'EDIT', 'DELETE'].includes(code)
    case contractStatusValue.signing:
      return ['REVOCATION'].includes(code)
    case contractStatusValue.finish:
      return ['DOWNLOAD', 'PRINT'].includes(code)
    case contractStatusValue.revoke:
      return ['DELETE', 'RESEND'].includes(code)
    case contractStatusValue.reject:
      return ['DELETE'].includes(code)
    case contractStatusValue.fail:
      return ['RESEND', 'PREVIEW', 'EDIT', 'DELETE'].includes(code)
    case contractStatusValue.overdue:
      return ['DELETE'].includes(code)
    case contractStatusValue.nullify:
      return ['DOWNLOAD'].includes(code)
    default:
      return false
  }
}
</script>
<style lang="scss" scoped>
.contract-details {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  font-size: 14px;
  background-color: #f4f4f5;
  z-index: 10;
  display: flex;
  flex-direction: column;
}
.details-header {
  padding: 12px 24px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  .title {
    color: #333333;
    font-size: 18px;
    line-height: 26px;
  }
}
.content {
  width: 100%;
  flex: 1;
  overflow-y: hidden;
  display: flex;
  .right {
    width: 280px;
    background-color: #fff;
    padding: 16px;
    overflow-y: auto;
    .item-row {
      margin-top: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      overflow: hidden;
    }
    .label {
      color: #666666;
      font-size: 14px;
      line-height: 22px;
      flex-shrink: 0;
    }
    .text {
      color: #333333;
      font-size: 14px;
      line-height: 22px;
      word-break: break-all;
    }
  }
}
</style>
